import api from "../../../api/axios";

const BASE_URL = "/api/v1/power/dashboard";

const getDashboardOverview = async () => {
  const response = await api.get(`${BASE_URL}/overview`);
  return response.data;
};

const dashboardService = {
  getDashboardOverview,
};

export default dashboardService;
